import * as React from "react";
import { SessionContextProvider, SessionContext } from "./SessionContextProvider";
import { SocialCoachSession } from "@/services/bedrock";

export interface AppContextState {
  session?: SocialCoachSession;
  clearSession: (isExplicitLogout?: boolean) => void;
  refreshSession: (background?: boolean) => Promise<SocialCoachSession | undefined>;
  loading: boolean;
}

export const AppContext = React.createContext<AppContextState>({
  clearSession: () => {},
  refreshSession: async () => {
    return undefined;
  },
  loading: false,
});

type AppContextProviderProps = {
  children: React.ReactNode; // 👈️ type children
};

export const AppContextProvider: React.FC<AppContextProviderProps> = (props: AppContextProviderProps) => {
  return (
    <SessionContextProvider>
      <SessionContext.Consumer>
        {sessionContext => {
          const state = sessionContext as AppContextState;
          return <AppContext.Provider value={state}>{props.children}</AppContext.Provider>;
        }}
      </SessionContext.Consumer>
    </SessionContextProvider>
  );
};
